<script>
/**
 * Component: NavigationItem
 *
 * @author PH
 */
export default {
  props: ["id", "title", "valid", "active"],

  data: function() {
    return {
      focused: false
    };
  },

  methods: {
    changeSection(id) {
      this.$store.commit("changeSection", {
        id: id
      });
    },

    focusElement(e) {
      if (9 === e.keyCode) {
        this.focused = true;
      }
    },

    unfocusElement(e) {
      this.focused = false;
    }
  }
};
</script>

<template>
  <div class="signup-navigation-item">
    <button
      type="button"
      :class="{valid: valid === true, invalid: valid === false, active: active === true, focused: focused}"
      @click="changeSection(id)"
      v-on:keyup="focusElement"
      v-on:blur="unfocusElement"
    >{{title}}</button>
  </div>
</template>

